import { render, staticRenderFns } from "./BbeeProductosServiciosSL.vue?vue&type=template&id=0c70c409"
import script from "./BbeeProductosServiciosSL.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosSL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports